export const BASE_URL = process.env.REACT_APP_NEXT_PUBLIC_BASE_URL;

export const CLICKUP_TICKET_STATUS = {
  OPEN: 'OPEN',
  INPROGRESS: 'IN PROGRESS',
  RESOLVED: 'RESOLVED',
  CLOSED: 'CLOSED'
};